import script from "./TableForFailedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./TableForFailedProducts.vue?vue&type=script&setup=true&lang=js"

import "./TableForFailedProducts.vue?vue&type=style&index=0&id=4bd39a66&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd39a66"]])

export default __exports__